'use strict';
import {CreateCardHOC} from '../../../components/lists/CreateCard';
import {ProjectForm} from '../ProjectForm';


export const CreateProjectCardComponent = CreateCardHOC(ProjectForm, {
  showIsPrivate: true,
  canEditIsPrivate: true,
  showLocationOrientation: false,
});



// WEBPACK FOOTER //
// ./src/js/projects/components/CreateProjectCard/CreateProjectCardComponent.js